import React from 'react';
import { useNode, useEditor } from '@craftjs/core';
import ContentEditable from 'react-contenteditable';

import { TextSettings } from './TextSettings';
import { useInheritedTextColor } from '../Container'; 
import { usePropagateDimensions } from '../../../hooks/usePropagateDimensions';

export const Text = ({
  fontSize,
  textAlign,
  fontWeight,
  color,
  shadow,
  text,
  margin,
}) => {
  const {
    connectors: { connect },
    actions: { setProp },
    parent,
    hasOwnColor,
  } = useNode((node) => ({
    parent: node.data.parent,
    hasOwnColor: node.data.props.color !== Text.craft.props.color,
  }));
  
  const { enabled } = useEditor((state) => ({
    enabled: state.options.enabled,
  }));

  const { propagateHeight, propagateWidth } = usePropagateDimensions();
  
  const inheritedColor = useInheritedTextColor();

  const finalColor = color || inheritedColor || { r: 0, g: 0, b: 0, a: 1 };

  return (
    <ContentEditable
      innerRef={connect}
      html={text}
      disabled={!enabled}
      onChange={(e) => {
        setProp((props) => (props.text = e.target.value), 500);
        if (parent) {
            propagateHeight(parent);
            propagateWidth(parent);
        }
      }}
      tagName="p"
      style={{
        width: '100%',
        margin: `${margin[0] || 0}px ${margin[1] || 0}px ${margin[2] || 0}px ${margin[3] || 0}px`,
        color: `rgba(${Object.values(finalColor)})`,
        fontSize: `${fontSize}px`,
        textShadow: `0px 0px 2px rgba(0,0,0,${(shadow || 0) / 100})`,
        fontWeight,
        textAlign,
      }}
    />
  );
};

Text.craft = {
  displayName: 'Texto',
  props: {
    fontSize: '15',
    textAlign: 'left',
    fontWeight: '400',
    color: null, 
    margin: [0, 0, 0, 0],
    shadow: 0,
    text: 'Escribe aquí tu texto',
  },
  related: {
    toolbar: TextSettings,
  },
};